import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=11c86532&scoped=true"
import script from "./page-loader.ts?vue&type=script&lang=ts&external"
export * from "./page-loader.ts?vue&type=script&lang=ts&external"
import style0 from "./page-loader.scss?vue&type=style&index=0&id=11c86532&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c86532",
  null
  
)

export default component.exports